export default {
  advancedSelect: {
    placeholder: 'Please select',
    copyTooltip: 'Copy selected content',
    emptyText: 'No data',
    loadingText: 'Searching...',
    retry: 'Retry',
    searchFailed: 'Search failed',
    unknownError: 'Unknown error',
    maxRetriesReached: 'Maximum retry attempts reached',
    noCopyContent: 'No content to copy',
    copySuccess: 'Copied successfully: {content}',
    copyFailed: 'Copy failed'
  }
}
